import api from "./api";

/* Seconds a player gets to type a qty / flip BOX after the number is complete (admin setting, 3–20, default 12). Cached per session. */
let secs = Number(sessionStorage.getItem("rl_book_wait")) || 12;
let loaded = false;
export const bookWait = () => {
  if (!loaded) { loaded = true; api.get("/config").then((r) => { const v = parseInt(r.data?.book_wait_secs); if (v >= 3 && v <= 20) { secs = v; sessionStorage.setItem("rl_book_wait", String(v)); } }).catch(() => {}); }
  return secs;
};
bookWait();  // warm up at app start so the very first countdown already uses the admin value
